class ArticleAsync extends HTMLElement {
  connectedCallback () {
    this.fetchSection()
  }

  async fetchSection () {
    const response = await fetch(`${this.handle}?sections=${this.sectionId}`).then(response =>
      response.json(),
    )
    const parser = new DOMParser()
    const html = parser
      .parseFromString(response[this.sectionId], 'text/html')
      .querySelector(`#shopify-section-${this.sectionId}`)

    this.innerHTML = html.innerHTML
  }

  get handle () {
    // eslint-disable-next-line compat/compat
    const url = new URL(this.dataset.url)
    return url.pathname
  }

  get sectionId () {
    return 'article-card'
  }
}

if (!customElements.get('article-async')) {
  customElements.define('article-async', ArticleAsync)
}
